import styled from 'styled-components';

const StatusLabel = styled.div<{ color: string }>`
  &&& {
    background-color: ${props => props.color};
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    display: inline-block;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    cursor: default;
  }
`;

export default StatusLabel;